/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  serviceId: ZodTypes.Id,
});

export const GetDeepthinkerRunStatus = {
  id: 'deepthinker-run-status.get',
  tag: 'Deepthinker',
  summary: 'Get latest deepthinker run status',
  description: 'Get latest deepthinker run status of a service',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.serviceId}/deepthinker/status`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            status: ZodTypes.DeepthinkerJobStatus,
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
